import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { UserForm } from './forms/UserForm';
import { useTeamStore } from '../../stores/teamStore';
import { User } from '../../types/user';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  user: User;
};

export const EditUserModal = ({ isOpen, onClose, user }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { roles, updateUser } = useTeamStore();

  const handleSubmit = async (data: Partial<User>) => {
    setIsLoading(true);
    setError('');

    try {
      await updateUser(user.id, {
        ...data,
        updatedAt: Date.now()
      });
      onClose();
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="تعديل بيانات العضو">
      {error && (
        <div className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
          {error}
        </div>
      )}
      <UserForm
        onSubmit={handleSubmit}
        initialData={user}
        roles={roles}
        isLoading={isLoading}
      />
    </Modal>
  );
};